import {
    getToday,
    relativeToday,
    getStartOfWeek,
    getEndOfWeek,
    getStartOfMonth,
    getStartOfLastMonth,
    getEndOfLastMonth,
} from 'utils/date-utils';

export const preselectedRanges = [
    {
        type: 'today',
        title: 'Today',
        dates: () => ({
            from: getToday(),
            to: getToday(),
        }),
    },
    {
        type: 'yesterday',
        title: 'Yesterday',
        dates: () => ({
            from: relativeToday(-1),
            to: relativeToday(-1),
        }),
    },
    {
        type: 'this_week_today',
        title: 'This week (Sun - Today)',
        dates: () => ({
            from: getStartOfWeek(),
            to: getToday(),
        }),
    },
    {
        type: 'last_7_days',
        title: 'Last 7 days',
        dates: () => ({
            from: relativeToday(-7),
            to: getToday(),
        }),
    },
    {
        type: 'this_week_sat',
        title: 'This week (Sun - Sat)',
        dates: () => ({
            from: getStartOfWeek(),
            to: getEndOfWeek(),
        }),
    },
    {
        type: 'last_14_days',
        title: 'Last 14 days',
        dates: () => ({
            from: relativeToday(-14),
            to: getToday(),
        }),
    },
    {
        type: 'month',
        title: 'This month',
        dates: () => ({
            from: getStartOfMonth(),
            to: getToday(),
        }),
    },
    {
        type: 'last_30_days',
        title: 'Last 30 days',
        dates: () => ({
            from: relativeToday(-30),
            to: getToday(),
        }),
    },
    {
        type: 'last_month',
        title: 'Last month',
        dates: () => ({
            from: getStartOfLastMonth(),
            to: getEndOfLastMonth(),
        }),
    },
];
